import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-view-reload',
  templateUrl: './view-reload.component.html',
  styleUrls: ['./view-reload.component.css']
})
export class ViewReloadComponent implements OnInit {

  constructor(
    private router: Router) { }

  ngOnInit() {
    this.router.navigate(['']);
  }

}
